import { render, staticRenderFns } from "./zuzhi.vue?vue&type=template&id=686fcb2c&scoped=true&"
import script from "./zuzhi.vue?vue&type=script&lang=ts&"
export * from "./zuzhi.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686fcb2c",
  null
  
)

export default component.exports